import { createReducer } from "@reduxjs/toolkit";
import { getCertificazioniLotto, getDettaglioLotto, refreshCertificazioniLotto, refreshDettaglioLotto, setPaginaSelezionataAction, setRicercaNominativo, setRicercaStatoCertificazione, setRicercaWorkflowCertificazione } from "./actions";
import { DettaglioCampagnaReducerType } from "./types";

const initialState: DettaglioCampagnaReducerType = {
  certificazioniLotto: undefined,
  dettaglioLotto: undefined,
  paginaSelezionata: 1,
  formRicerca: {
    nominativo: "",
    statoCertificazione: undefined,
    workflowCertificazione: undefined
  }
}

export const dettaglioCampagnaReducer = createReducer(initialState, (builder) => {

  builder
    .addCase(getCertificazioniLotto.pending, (state) => {
      state.certificazioniLotto = initialState.certificazioniLotto;
    })
    .addCase(getCertificazioniLotto.fulfilled, (state, action) => {
      state.certificazioniLotto = action.payload;
    })
    .addCase(getDettaglioLotto.pending, (state) => {
      state.dettaglioLotto = initialState.dettaglioLotto;
    })
    .addCase(getDettaglioLotto.fulfilled, (state, action) => {
      state.dettaglioLotto = action.payload;
    })
    .addCase(refreshDettaglioLotto.fulfilled, (state, action) => {
      state.dettaglioLotto = action.payload;
    })
    .addCase(refreshCertificazioniLotto.fulfilled, (state, action) => {
      state.paginaSelezionata = 1;
      state.certificazioniLotto = action.payload;
    })
    .addCase(setRicercaNominativo, (state, action) => {
      state.formRicerca.nominativo = action.payload;
    })
    .addCase(setRicercaStatoCertificazione, (state, action) => {
      state.formRicerca.statoCertificazione = action.payload;
    })
    .addCase(setRicercaWorkflowCertificazione, (state, action) => {
      state.formRicerca.workflowCertificazione = action.payload;
    })
    .addCase(setPaginaSelezionataAction, (state, action) => {
      state.paginaSelezionata = action.payload;
    })
});
